import { FilterCounterOverride } from 'components/filters/FilterIconWithCounterFromForm';

export const getPipelineFilterLocalStorageKey = (userUid: string) =>
  `pipeline-user:${userUid}`;

/**
 * The lead status filter defaults to RELEVANT rather than "All" (empty string),
 * so it narrows the list before the field ever becomes dirty.
 */
export const PIPELINE_LEAD_STATUS_FILTER_COUNTER_OVERRIDES = [
  { name: 'leadStatus', getCount: (value: unknown) => (value === '' ? 0 : 1) },
] as const satisfies FilterCounterOverride[];

export const pipelineFilterFormExpandedStorageKey = 'pipeline-filters-expanded';

// Like propertyCalendarGraphQLQuery, but also fetches `tags` for cross-filtering.
export const pipelinePropertiesGraphQLQuery = `
    uid,
    name,
    isActive,
    mainPicture{tinyThumbnail, largeThumbnail},
    picture,
    businessType,
    propertyType,
    masterUnitUid,
    availability{maxGuests, checkInTimeStart, checkOutTime},
    pricing{currency},
    tags,
    subUnits{
      uid,
      availability{checkInTimeStart, checkOutTime, maxGuests},
      name,
      mainPicture{tinyThumbnail, largeThumbnail},
      businessType,
      propertyType,
      masterUnitUid,
      isActive,
      tags,
    },
    numberOfSubUnits,
    unitTypes{
      uid,
      name,
      mainPicture{tinyThumbnail},
      availability{maxGuests, checkInTimeStart, checkOutTime},
      businessType,
      hotelUid,
      units{uid, name, isActive},
      isActive,
      tags,
    },
  `;
